import Vue from 'vue'
import Vuex from 'vuex'
import player from './modules/player'
import recognition from './modules/recognition'
import settings from './modules/settings'
import stats from './modules/stats'
import auth from './modules/auth'
import practiceTimerPlugin from './plugins/practiceTimer'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    player,
    recognition,
    settings,
    stats,
    auth
  },
  plugins: [practiceTimerPlugin]
});

// Debug/e2e handle only; app code uses `this.$store`.
window.__storeInstance = store;

export default store;
